import React, { useEffect } from "react";
import $ from "jquery";
import leftPng from "../../../../content/images/left.png";
import dateTimePng from "../../../../content/images/date-time.png";
import * as omnimap from "../../../../api/omnimap/omnimapActions";

class Detail extends React.Component {
  constructor(props) {
    super(props);
    this.rowId =
      this.props.match &&
      this.props.match.params &&
      this.props.match.params.rowId;
    this.state = {
      rowData: this.props.history.location.state.rowData,
      extraColumn: [],
      isDetailLoading: true,
    };
  }

  async componentDidMount() {
    $("#cover-spin").show(0);
    let realtions = await omnimap.GetRelationAction(
      this.state.rowData.identification,
      1,
      30
    );
    let rowDetail = await omnimap.GetRowOfDetailAction(
      this.state.rowData.identification
    );
    let extraColumnValue = rowDetail.data.content.extravelden;

    const onderhoudslaagIndex = realtions.data.findIndex(
      (x) =>
        x.relationships.related_instance_definition.name === "Onderhoudslaag"
    );
    if (onderhoudslaagIndex > 0) {
      const onderhoudslaagId =
        realtions.data[onderhoudslaagIndex].relationships.related_instance
          .identification;
      var extravelden = [];
      let result = await omnimap.GetRowOfDetailAction(onderhoudslaagId);
      result.data.content.algemeen.extravelden &&
        extraColumnValue &&
        result.data.content.algemeen.extravelden.map((value, index) => {
          extravelden.push({
            name: value.name,
            // find array index and find value by index
            value: extraColumnValue[Object.keys(extraColumnValue)[index]],
          });
        });
      await this.setState({ extraColumn: extravelden, isDetailLoading: false });
      $("#cover-spin").hide(0);
    }
  }

  render() {
    return (
      <div id="detailSide" /*className="d-none"*/>
        <div className="detail-title">Beheereenheid in detail</div>
        <div className="mt5">
          <a
            className="back-page-link"
            role="button"
            onClick={() => {
              this.props.history.push(
                "/management-maintenance/management-units/"
              );
            }}
          >
            <img src={leftPng} width={9} height={12} /> &nbsp;Terug naar
            beheereenheden
          </a>
        </div>
        {!this.state.isDetailLoading && (
          <>
            <div className="row clearfix">
              <div className="col-lg-4 text-center">
                <div className="box-detail-active">
                  <div className="box-title-1-active">Gisratio ID</div>
                  <div className="box-title-2-active" id="algemeenGisratioid">
                    {this.state.rowData.algemeenGisratioid}
                  </div>
                </div>
              </div>
              <div className="col-lg-4 text-center">
                <div className="box-detail">
                  <div className="box-title-1">Beheereenheid</div>
                  <div className="box-title-2" id="beheereenheidNaam">
                    {this.state.rowData.beheereenheidNaam}
                  </div>
                </div>
              </div>
              <div className="col-lg-4 text-center">
                <div className="box-detail">
                  <div className="box-title-1">Discipline</div>
                  <div className="box-title-2" id="discipline">
                    {this.state.rowData.discipline}
                  </div>
                </div>
              </div>
              <div className="col-lg-4 text-center">
                <div className="box-detail">
                  <div className="box-title-1">Laag</div>
                  <div className="box-title-2" id="laag">
                    {this.state.rowData.laag}
                  </div>
                </div>
              </div>
              <div className="col-lg-4 text-center">
                <div className="box-detail">
                  <div className="box-title-1">Prestatie</div>
                  <div className="box-title-2" id="prestatie">
                    {this.state.rowData.prestatie}
                  </div>
                </div>
              </div>
              <div className="col-lg-4 text-center">
                <div className="box-detail">
                  <div className="box-title-1">Gebiedsnaam</div>
                  <div className="box-title-2" id="gebiedNaam">
                    {this.state.rowData.gebiedNaam}
                  </div>
                </div>
              </div>
              {this.state.extraColumn.map((item) => (
                <div className="col-lg-4 text-center">
                  <div className="box-detail">
                    <div className="box-title-1">{item.name}</div>
                    <div className="box-title-2" id="gebiedNaam">
                      {item.value}
                    </div>
                  </div>
                </div>
              ))}
            </div>
            <div className="row clearfix">
              <div className="col-sm-6">
                <div className="inp-labl">Start horizon</div>
                <div className="input-group">
                  <div className="input-group-prepend">
                    <span className="input-group-text">
                      <img src={dateTimePng} width={30} height={28} />
                    </span>
                  </div>
                  <input
                    type="text"
                    className="form-control inp-h inpp"
                    id="startDate"
                    disabled
                    placeholder={
                      String(this.state.rowData.horizon).split(" ")[0]
                    }
                  />
                </div>
              </div>
              <div className="col-sm-6">
                <div className="inp-labl">Eind horizon</div>
                <div className="input-group">
                  <div className="input-group-prepend">
                    <span className="input-group-text">
                      <img src={dateTimePng} width={30} height={28} />
                    </span>
                  </div>
                  <input
                    type="text"
                    className="form-control inp-h inpp"
                    id="endDate"
                    disabled
                    placeholder={
                      String(this.state.rowData.horizon).split(" ")[1]
                    }
                  />
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    );
  }
}

export default Detail;
